import { render } from "./MissingContributionsInquiry.vue?vue&type=template&id=f4201d48&ts=true"
import script from "./MissingContributionsInquiry.vue?vue&type=script&lang=ts"
export * from "./MissingContributionsInquiry.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__